export default {"src":"/_next/static/media/circle-bg.62ab132f.svg","height":302,"width":301,"blurWidth":0,"blurHeight":0};